
import { CommandDispatcher } from "@/modules/shared/domain/CommandDispatcher"

export class EmitSignalCommand {
    constructor(
        private readonly dispatcher: CommandDispatcher
    ) {}
    
    async run(company_id:number): Promise<any> {
        let args = {
            code: 'company_selected',
            company_id: company_id
        }
        await this.dispatcher.dispatch('emit.signal', args)
    }
}